import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { FaMapMarkerAlt } from "react-icons/fa";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import heroImg from "../assests/images/hero.jpg";
import { useNavigate } from "react-router-dom";

export default function DestinationDetails() {
    const { slug } = useParams();
    const [destination, setDestination] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDestination = async () => {
            try {
                const res = await axios.get(
                    `https://beachhotelsdubai.com/api/destinations/${slug}`
                );
                setDestination(res.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchDestination();
    }, [slug]);

    if (loading) {
        return (
            <div className="flex justify-center py-20">
                <div className="animate-spin h-12 w-12 border-4 border-[#0F172A] border-t-transparent rounded-full"></div>
            </div>
        );
    }

    if (!destination) {
        return <p className="text-center py-20">Destination not found</p>;
    }

    return (
        <div>


            <Hero
                heightClass="sm:h-[230px] md:h-[250px] lg:h-[200px]"
                title="Destinations"
                backgroundImage={heroImg}
                contentClass=""
            />
            <div className="max-w-7xl mx-auto px-4 py-12">
                {/* Title */}
                <h1 className="text-4xl font-bold mb-8 text-[#0F172A]">
                    Hotels in {destination.name}
                </h1>

                {/* Hotels Grid */}
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {destination.hotels.length > 0 ? (
                        destination.hotels.map((hotel) => (
                            <div
                                key={hotel.id}
                                onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                className="bg-white rounded-2xl shadow-md hover:shadow-xl hover:ring-2 hover:ring-[#0F172A] transition overflow-hidden cursor-pointer"
                            >
                                <img
                                    src={`https://beachhotelsdubai.com/uploads/hotels/${hotel.image}`}
                                    className="h-56 w-full object-cover"
                                />

                                <div className="p-5">
                                    <h3 className="text-xl font-semibold">{hotel.name}</h3>

                                    <p className="text-sm text-[#0F172A] flex items-center gap-1 mt-1">
                                        <FaMapMarkerAlt />
                                        {destination.name}
                                    </p>

                                    <p className="text-sm text-gray-600 mt-2 line-clamp-2">
                                        {hotel.short_description.replace(/<[^>]*>/g, "")}
                                    </p>

                                    <div className="mt-4 font-bold text-[#0F172A]">
                                        {Math.round(hotel.price_per_night)} AED / night
                                    </div>

                                    <button className="mt-4 w-full bg-[#0F172A] hover:bg-[#e85a2a] text-white py-2 rounded-lg transition">
                                        View Details
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No hotels found for this destination</p>
                    )}
                </div>
            </div>

        </div >
    );
}